import {
  Banner,
  OurLoyalCustomer,
  DownloadApps,
} from "src/components/CashLoan/Components";
import BreadcrumbComponent from "src/components/UserInterface/BreadcrumbComponent";
import { CashLoanBreadcrumb } from "src/data/DataBreadcrumb";
import React from "react";
import { CashLoanGeneralHeader, CashLoanCards } from "./Components";
import { env } from "src/utils/env";

const HomePage = () => {
  return (
    <React.Fragment>
      <BreadcrumbComponent items={CashLoanBreadcrumb}></BreadcrumbComponent>
      <Banner
        img={`${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/6abdd3d0-2911-4e52-9870-b1e3f497f7df/pembiayaan-tunai-general-banner.png`}
      />
      <CashLoanGeneralHeader />
      <CashLoanCards />
      <OurLoyalCustomer />
      <DownloadApps />
    </React.Fragment>
  );
};

export default HomePage;
